<template>
  <div>
    <wc-page-title title='Ready to sell'>
      <template v-slot:rightSide>
        <wc-toolbar-search v-model='search'></wc-toolbar-search>
      </template>
    </wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box hideToolbar>
            <estimates-table
              :isLoading='isLoading'
              :estimates='filteredEstimates'
              :search='search'
            ></estimates-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import estimatesAPI from '@/modules/estimates/api/estimates'
import EstimatesTable from '../components/EstimatesTable'

export default {
  name: 'ready-to-sell',
  data: () => ({
    isLoading: true,
    estimates: [],
    search: '',
    headers: [
      { text: 'Date', value: 'estimate_date', width: '120' },
      { text: 'Division', value: 'division_obj.division', width: '120' },
      { text: 'Name', value: 'name' },
      { text: 'Site Address', value: 'site_address' },
      { text: 'Site City', value: 'site_city' },
      { text: 'Type', value: 'type_display', align: 'center' },
      { text: 'Status', value: 'status_display', align: 'center' }
    ]
  }),
  mounted () {
    this.getData()
  },
  computed: {
    filteredEstimates () { 
      return _.orderBy(this.estimates, ['estimate_date', 'name'], ['desc','asc']);
    }
  },
  methods: {
    async getData () {
      this.isLoading = true;
      this.estimates = await estimatesAPI.getEstimatesReadyToSell();
      this.isLoading = false;
    },
    openEstimate (est) {
      this.$router.push({ name: est.division_obj.division + 'Estimate', params: { id: est.id } });
    }
  },
  components: {
    'estimates-table': EstimatesTable
  }
}
</script>
